<template>
  <div class="md-layout">
    <div centered class="md-layout-item md-xsmall-size-100 md-small-size-100 md-medium-size-100 md-large-size-80 md-xlarge-size-70 " style="margin:0 auto;">
      <div class="md-layout">
        <div class="md-layout-item md-size-100 md-small-size-100">
          <div class="maintenance-msg" v-if="showMaintenance" v-html="$t('maintenance-msg')"></div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
// window.console.clear()

export default   {
  name: 'Maintenance',
    data: () => ({
      showMaintenance: false
    }),
    async created() {
      let dtNow = new Date()
      let dtEnd = new Date('2022-10-09 3:00:00 PM')

      if (dtNow < dtEnd) {
        this.showMaintenance = true
      }

    }
}
</script>

<style>
  .maintenance-msg {
    background-color:#f0f8ff;
    color: #2f2f2f;
    width:85%;
    padding:10px;
    margin: 0 auto 20px auto;
    border:1px dashed #555555;
  }
</style>